import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const stors = new Vuex.Store({
  state() {
    return {
      status: localStorage.getItem("isCollapse") == "true" ? true : false,
      leftMenu: [],
      activate: "",
      tagList: [],
      menuList: [],
      is_Work: false,
      is_Menu:false,
      headstyle: "",
      noFrameActivate: "",

    };
  },
  getters: {
    is_Work: (state) => {
      return state.is_Work;
    },
    is_Menu: (state) => {
      return state.is_Menu;
    },
    GET_STATUS: (state) => {
      return state.status;
    },
    GET_LEFT_MENU: (state) => {
      return state.leftMenu;
    },
    GET_ACTIVATE: (state) => {
      return state.activate;
    },
    GET_NO_FRAME_ACTIVATE: (state) => {
      return state.activate;
    },
    GET_TAGLIST: (state) => {
      return state.tagList;
    },
    GET_MENU_LIST: (state) => {
      return state.menuList;
    },
    GET_HEADSTYLE: (state) => {
      return state.headstyle;
    },
  },
  mutations: {
    headstyleChange(state, data) {
      if (data.userPath && data.userObject) {
        state.headstyle = data.userPath  + data.userObject;
      } else {
        state.headstyle = null;
      }
    },
    isworkchange(state, data) {
      state.is_Work = data;
    },
    isMenuChange(state,data){
      state.is_Menu = data;
    },

    menuChange(state, status) {
      localStorage.setItem("isCollapse", status);
      state.status = status;
    },
    leftMenuChange(state, data) {
      state.leftMenu = data.menu;
    },
    menuListChange(state, data) {
      state.menuList = data.list;
    },
    activateChange(state, data) {
      state.activate = data.activate;
    },
    noFrameActivateChange(state, data) {
      state.noFrameActivate = data.activate;
    },
    addTagListChange(state, data) {
      let index = state.tagList.findIndex(
        (v) => v.path.split("?")[0] == data.path.split("?")[0]
      );
      if (index == -1 && data.name.indexOf("加载中") == -1) {
        state.tagList.push(data);
      } else if (index > -1) {
        state.tagList[index].path = data.path;
      }
    },
    deleteTagListChange(state, path) {
      let index = state.tagList.findIndex((v) => v.path == path);
      state.tagList.splice(index, 1);
    }
  },
});
export default stors;
